import { APP_NAMESPACE } from '../../../store'
import { isEmpty } from 'lodash'
import AdyenCheckout from '@adyen/adyen-web'
import '@adyen/adyen-web/dist/adyen.css'
import { getCurrency } from '../../../utils/currency'
import { mapGetters } from 'vuex'
import Ready from '../../../common/ready'

export const adyenPaymentMethodName = {
  APPLE_PAY: 'ApplePay',
  GOOGLE_PAY: 'PayWithGoogle'
}

const eventMap = {}

export default {
  data() {
    return {
      adyenPaymentInitialized: false,
      paymentMessage: null,
      observer: null,
      rootNodeReady: new Ready(),
      adyenContainer: null,
      adyenPayMethodName: ''
    }
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, ['adyenPaymentInfo', 'billToAddress']),
    isAdyenPaymentAvailable() {
      return (
        this.adyenPaymentInfo.adyenPaymentMethodsObject && !isEmpty(this.adyenPaymentInfo.adyenPaymentMethodsObject)
      )
    },
    isAdyenApplePayEnabled() {
      const paymentMethodsEnabled = this.adyenPaymentInfo.adyenPaymentMethodsEnabled || []
      return this.isAdyenPaymentAvailable && paymentMethodsEnabled.includes(adyenPaymentMethodName.APPLE_PAY)
    },
    isAdyenGooglePayEnabled() {
      const paymentMethodsEnabled = this.adyenPaymentInfo.adyenPaymentMethodsEnabled || []
      return this.isAdyenPaymentAvailable && paymentMethodsEnabled.includes(adyenPaymentMethodName.GOOGLE_PAY)
    }
  },
  methods: {
    initAdyenPayment(adyenPayMethodName, config) {
      this.adyenPayMethodName = adyenPayMethodName
      if (this.adyenPaymentInitialized) {
        return
      }

      this.adyenContainer = config.adyenContainer

      const adyenPayMethodType = adyenPayMethodName.toLowerCase()
      const adyenPaymentMethodsObject = this.getAdyenPayMethodConfiguration(adyenPayMethodType)

      let locale = null
      let environment = null
      let clientKey = null
      let merchantId = null
      let currency = null
      let countryCode = null
      const adyenPayConfigData = this.adyenPaymentInfo.adyenPayConfigData

      if (adyenPayConfigData) {
        locale = adyenPayConfigData.locale
        environment = adyenPayConfigData.environment
        clientKey = adyenPayConfigData.clientKey
        currency = getCurrency() || 'USD'
        countryCode = this.billToAddress?.country?.toUpperCase() || 'US'
      }

      const paymentMethodsConfig = adyenPaymentMethodsObject && adyenPaymentMethodsObject.configuration
      let checkoutConfig = {}
      if (paymentMethodsConfig) {
        merchantId = paymentMethodsConfig.merchantId
        if (adyenPayMethodName === adyenPaymentMethodName.APPLE_PAY) {
          checkoutConfig = { merchantId, merchantName: paymentMethodsConfig.merchantName }
        } else if (adyenPayMethodName === adyenPaymentMethodName.GOOGLE_PAY) {
          checkoutConfig = { merchantId, gatewayMerchantId: paymentMethodsConfig.gatewayMerchantId }
        }
      }

      const checkoutInitConfig = { locale, environment, clientKey, adyenPaymentMethodsObject }

      const paymentOptions = {
        amount: { currency, value: 0.01 },
        countryCode,
        configuration: checkoutConfig,
        buttonType: config.buttonType,
        buttonColor: config.buttonColor,
        onClick: (resolve) => {
          this.$emit('submit-start')
          resolve()
        },
        onAuthorized: config.onAuthorizedCallback,
        onError: () => this.$emit('submit-error')
      }
      if (adyenPayMethodName === adyenPaymentMethodName.GOOGLE_PAY) {
        paymentOptions.emailRequired = true
      }
      const adyenPayment = new AdyenCheckout(checkoutInitConfig).create(adyenPayMethodType, paymentOptions)

      adyenPayment
        .isAvailable()
        .then(() => {
          this.paymentMessage = config.paymentSupportedMsg
          adyenPayment.mount(config.adyenContainer)
          this.adyenPaymentInitialized = true
        })
        .catch(() => {
          this.adyenFormMounted()
          this.paymentMessage = config.paymentUnsupportedMsg
        })
    },
    getAdyenPayMethodConfiguration(payMethodType) {
      const adyenPaymentMethodsObject = this.adyenPaymentInfo.adyenPaymentMethodsObject
      if (
        adyenPaymentMethodsObject &&
        adyenPaymentMethodsObject.paymentMethods &&
        Array.isArray(adyenPaymentMethodsObject.paymentMethods)
      ) {
        return adyenPaymentMethodsObject.paymentMethods.find(
          (payMethod) => payMethod.configuration && payMethod.type === payMethodType
        )
      }
      return null
    },
    watchButtonIsReady() {
      if (!this.adyenContainer) return
      this.observer = new MutationObserver(() => {
        const submitbutton = this.adyenContainer.querySelector('button')
        if (submitbutton) {
          this.adyenFormMounted()
        }
      })
      this.observer.observe(this.adyenContainer, { attributes: true, childList: true, subtree: true })
    },
    adyenFormMounted() {
      this.rootNodeReady.solved()
      if (!this.observer) return
      this.observer.disconnect()
      this.observe = null
    },
    setSubmitButtonStatus() {
      if (!this.adyenContainer) return
      const submitbutton = this.adyenContainer.querySelector('button')
      if (!submitbutton) return
      if (this.saveDisabled) {
        submitbutton.setAttribute('disabled', 'true')
      } else {
        submitbutton.removeAttribute('disabled')
      }

      if (!eventMap[this.adyenPayMethodName]) {
        const _this = this
        eventMap[this.adyenPayMethodName] = function () {
          _this.$emit('authorize')
        }
        submitbutton.addEventListener('click', eventMap[this.adyenPayMethodName])
      }
    }
  },
  watch: {
    saveDisabled: {
      immediate: true,
      handler() {
        this.rootNodeReady.ready(() => this.setSubmitButtonStatus())
      }
    }
  }
}
